/* eslint-disable */
import React, { useState } from 'react';

/**
 * RolePicker — chip grid for assignment roles + "Other" freetext fallback.
 * Props:
 *   roles       — array of {id, name, isActive, isPlantDefault}
 *   value       — currently selected role name (string)
 *   onChange     — (roleName: string) => void
 */
export default function RolePicker({ roles, value, onChange }) {
  const [otherMode, setOtherMode] = useState(false);
  const [otherText, setOtherText] = useState('');
  const activeRoles = (roles || []).filter(r => r.isActive).sort((a, b) => a.sortOrder - b.sortOrder);

  const handleOtherConfirm = () => {
    if (otherText.trim()) {
      onChange(otherText.trim());
      setOtherMode(false);
    }
  };

  const chipStyle = (isActive) => ({
    padding: '9px 6px',
    background: isActive ? 'rgba(255,83,13,0.15)' : 'var(--surface-inset)',
    border: '1px solid ' + (isActive ? 'rgba(255,83,13,0.6)' : 'var(--border-default)'),
    borderRadius: 8,
    color: isActive ? '#ff530d' : 'var(--text-default)',
    fontFamily: 'inherit',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'all 0.15s ease',
  });

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, marginBottom: otherMode ? 6 : 0 }}>
        {activeRoles.map(r => (
          <button
            key={r.id}
            type="button"
            style={chipStyle(value === r.name)}
            onClick={() => { onChange(r.name); setOtherMode(false); }}
          >
            {r.name}
          </button>
        ))}
        {!otherMode && (
          <button
            type="button"
            style={{ ...chipStyle(false), gridColumn: '1 / -1', marginTop: 2 }}
            onClick={() => setOtherMode(true)}
          >
            + Other
          </button>
        )}
      </div>
      {otherMode && (
        <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
          <input
            autoFocus
            value={otherText}
            onChange={e => setOtherText(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleOtherConfirm(); }}
            placeholder="Custom role name"
            style={{
              flex: 1, padding: '8px 10px',
              background: 'var(--surface-inset)', border: '1px solid var(--border-default)',
              borderRadius: 8, color: 'var(--text-default)', fontFamily: 'inherit', fontSize: 13,
            }}
          />
          <button
            type="button"
            onClick={handleOtherConfirm}
            style={{
              padding: '8px 14px', background: '#ff530d', color: '#fff',
              border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 12, cursor: 'pointer',
            }}
          >
            Set
          </button>
        </div>
      )}
    </div>
  );
}
